import React from 'react';
import { connect } from 'react-redux';
import { toPlainObject } from 'lodash';

import { STATIC_ROOT } from '../../../../constants';
import { TREE_PARITY_EURO_TTC } from '../../../../constants/payment';
import { PAYMENT_REQUEST_TYPE_NURSURY } from '../../../../services/account/paymentrequest/request/constants';

import {
    sendPaymentRequest,
    reset,
    setTimeoutId
} from '../../../../services/account/paymentrequest/request/actions';

import { getValidatedAmount } from '../../../../services/account/gains/selector';
import { getOnGoingPaidAmount } from '../../../../services/account/paymentrequest/ongoing/selector';
import * as paymentRequestSelector from '../../../../services/account/paymentrequest/request/selector';

import { formatAmountCurrency } from '../../../../utils';
import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';
import { minusAmount, multiplyAmount, truncateAmount } from '../../../../utils/mathUtils';

import SvgComponent from '../../../SvgComponent';
import { FormComponent, LegendFieldComponent } from '../../../../components/form';

import './PaymentRequestFormComponent.scss';

const FORM_NAME = 'paymentrequest-form-green';

class PaymentRequestPepiniere extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            number: 1
        };
    }

    submit = formData => {
        const { sendPaymentRequest, timeoutId } = this.props;
        const { number } = this.state;

        clearTimeout(timeoutId);

        const treeCost = number * TREE_PARITY_EURO_TTC;
        const body = { requestedAmount: treeCost };

        sendPaymentRequest(PAYMENT_REQUEST_TYPE_NURSURY, body);
    };

    handleClickPlus = () => {
        this.setState({
            number: this.state.number + 1
        });
    };

    handleClickMoins = () => {
        this.setState({
            number: this.state.number - 1
        });
    };

    render() {
        const {
            i18n,
            i18nCommon,
            requestSubmit,
            errorSubmit,
            errorMessage,
            validatedCashbackAmount,
            paymentRequestTotalAmount
        } = this.props;
        const { number } = this.state;

        const treeCost = multiplyAmount(number, TREE_PARITY_EURO_TTC);
        const treeCostPlusOne = multiplyAmount(number + 1, TREE_PARITY_EURO_TTC);

        const validatedMinusPaymentRequest = truncateAmount(
            minusAmount(validatedCashbackAmount, paymentRequestTotalAmount)
        );
        const remainingJackpotAfterPayment =
            minusAmount(validatedMinusPaymentRequest, treeCost) < 0
                ? 0
                : minusAmount(validatedMinusPaymentRequest, treeCost);

        const lessDisabled = number <= 1;
        const moreDisabled = minusAmount(validatedMinusPaymentRequest, treeCostPlusOne) < 0;

        return (
            <div className="payment-request">
                <p className="resume">{i18n.DISCOVER_NURSURY}</p>

                <div className="nursury">
                    <img
                        src={`${STATIC_ROOT}/tree/reforestAction-logo.png`}
                        width="130"
                        height="45"
                        alt=""
                    />
                    <div>
                        <p>
                            {convertHtmlToReactDomWithParams(
                                i18n.NURSURY.REFOREST_ACTION.DESCRIPTION
                            )}
                        </p>
                        <p>
                            {convertHtmlToReactDomWithParams(i18n.NURSURY.REFOREST_ACTION.TEXT_1)}
                        </p>
                        <ul>
                            <li>
                                {convertHtmlToReactDomWithParams(
                                    i18n.NURSURY.REFOREST_ACTION.TEXT_2
                                )}
                            </li>
                            <li>
                                {convertHtmlToReactDomWithParams(
                                    i18n.NURSURY.REFOREST_ACTION.TEXT_3
                                )}
                            </li>
                        </ul>
                        <p>
                            {convertHtmlToReactDomWithParams(
                                i18n.NURSURY.REFOREST_ACTION.KNOW_MORE
                            )}
                        </p>
                    </div>
                </div>

                <FormComponent
                    form={FORM_NAME}
                    classNameInputContainer="payment-request-form"
                    onSubmit={this.submit}
                    requestSubmit={requestSubmit}
                    errorSubmit={errorSubmit}
                    submitText={i18n.PAYMENT_REQUEST_BUTTON}>
                    <React.Fragment>
                        <p className="field-label">{i18n.TREE_PLANT}</p>
                        <div className="choice">
                            <button
                                type="button"
                                onClick={this.handleClickMoins}
                                disabled={lessDisabled}>
                                -
                            </button>
                            <p>{this.state.number}</p>
                            <button
                                type="button"
                                onClick={this.handleClickPlus}
                                disabled={moreDisabled}>
                                +
                            </button>
                        </div>
                    </React.Fragment>

                    <React.Fragment>
                        <p className="tree-conversion">
                            {convertHtmlToReactDomWithParams(
                                i18n.CONVERT_TREE_EURO,
                                formatAmountCurrency(treeCost)
                            )}
                        </p>
                    </React.Fragment>
                    <React.Fragment>
                        <div className="information-div">
                            <span>
                                <SvgComponent
                                    src={`${STATIC_ROOT}/information.svg`}
                                    width="20"
                                    height="20"
                                    aria-hidden="true"
                                    focusable="false"
                                />
                            </span>
                            <span>
                                {convertHtmlToReactDomWithParams(
                                    i18nCommon.REMAINING_JACKPOT_AFTER_PAYMENT_INDICATION,
                                    formatAmountCurrency(remainingJackpotAfterPayment)
                                )}
                            </span>
                        </div>
                    </React.Fragment>

                    <React.Fragment>
                        {errorMessage && (
                            <LegendFieldComponent classNameInputContainer="color-err">
                                {errorMessage}
                            </LegendFieldComponent>
                        )}
                    </React.Fragment>
                </FormComponent>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const user = toPlainObject(state.account.user);
    const validatedCashbackAmount = getValidatedAmount(state);
    const paymentRequestTotalAmount = getOnGoingPaidAmount(state);

    return {
        i18n: state.i18n.page.ACCOUNT.CASHBACK_JACKPOT.PAYMENT_REQUEST_FORM.TREE,
        i18nCommon: state.i18n.page.ACCOUNT.CASHBACK_JACKPOT.PAYMENT_REQUEST_FORM,
        user: user,
        requestSubmit: paymentRequestSelector.isRequesting(state),
        errorSubmit: paymentRequestSelector.isError(state),
        errorMessage: paymentRequestSelector.getError(state),
        validatedCashbackAmount: validatedCashbackAmount,
        paymentRequestTotalAmount: paymentRequestTotalAmount,
        timeoutId: paymentRequestSelector.getTimeoutId(state)
    };
};

const mapDispatchToProps = {
    sendPaymentRequest,
    reset,
    setTimeoutId
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentRequestPepiniere);



// WEBPACK FOOTER //
// ./src/components/pages/account/cashback/PaymentRequestPepiniere.js